/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-18 23:47:16
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-15 10:23:09
 * @FilePath: /unifyxp-v2-store-portal/src/tools/hooks/listPageHooks/index.ts
 */
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
//import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { EnumQueryType } from 'src/constrains/Query1';
import { onTagClose1 } from 'src/constrains/Query1/tools';
import { searchConditions as _searchConditions } from 'src/tools/helper';
import { queryConvert1 as queryConvert } from 'src/tools/queryConvert';

const useQueries = (
  filters,
  sortList,
  customerConvertQuery?,
  defaultValue?,
) => {
  const [searchConditions, setSearchConditions] = useState({
    ...(defaultValue || _searchConditions),
  });
  const clearSearchState = () => {
    setSearchConditions({ ..._searchConditions });
  };
  const onSearchChange = (data) => {
    const { type } = data;

    const _searchConditions = _.cloneDeep(searchConditions);
    if (type === EnumQueryType.search) {
      const { search } = data;
      _searchConditions.search.push(search);
    }
    if (type === EnumQueryType.filter) {
      const { filter } = data;

      Object.keys(filter).forEach((key) => {
        _searchConditions.filter[key] = filter[key];
      });
    }
    if (type === EnumQueryType.sort) {
      const { sort } = data;
      _searchConditions.sort = sort;
    }
    if (type === EnumQueryType.closeTag) {
      const { item } = data;
      onTagClose1({ state: _searchConditions, item });
    }
    setSearchConditions(_searchConditions);
  };
  const queryProps = {
    filters,
    sortList,
    searchConditions,
    onSearchChange,
  };
  const search = React.useMemo(() => {
    return queryConvert(searchConditions, customerConvertQuery || convertQuery);
  }, [searchConditions]);
  return { clearSearchState, queryProps, search };
};

const convertQuery = (filter) => {
  const re: any = {};
  if (filter.tags) {
    if (filter.tags.length > 0) {
      re.tags = filter.tags.map((i) => {
        const { value } = i;
        return { uuid: value };
      });
    }
  }
  if (filter.salesChannel) {
    if (filter.salesChannel.length > 0) {
      re.salesChannel = filter.salesChannel[0].value;
    }
  }
  if (filter.productTypes) {
    if (filter.productTypes.length > 0) {
      re.productTypes = filter.productTypes.map((i) => {
        const { value } = i;
        return value;
      });
    }
  }
  if (filter.productStatuses) {
    if (filter.productStatuses.length > 0) {
      re.productStatuses = filter.productStatuses.map((i) => {
        const { value } = i;
        return value;
      });
    }
  }
  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};
const useSelectRows = (products, selected?) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>(
    selected || [],
  ); //当前页选择的产品
  const [selectedAll, setSelectedAll] = useState(false);
  const [mappedSelectedKeys, setMappedSelectedKeys] = React.useState<string[]>(
    selectedRowKeys.reduce((pre, now) => {
      return [...pre, now];
    }, []),
  ); //不管分页所有选择的产品
  const onSelectChange = (selections) => {
    //selections=当前页面选择
    //选择全部时也会触发这个方法
    if (selectedAll && selections.length < selectedRowKeys.length) {
      //判断用户是否在减选
      setSelectedAll(false);
      updateMappedSelectedKeys(selections, false, []);
    } else {
      updateMappedSelectedKeys(selections, true);
    }
    setSelectedRowKeys(selections);
    // setSelectedAll(false);
    // setMappedSelectedKeys([]);
  };
  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: (selections) => {
      onSelectChange(selections);
      // setSelectedAll(false);
    },
    columnWidth: 60,
    selectAll: () => {
      onSelectChange([]);
      // setSelectedAll(false);
    },
    //hideSelectAll: true,
  };
  const updateMappedSelectedKeys = (
    currentPageSelection,
    selectedAll,
    iniValue?,
  ) => {
    const _keys = _.cloneDeep(iniValue || mappedSelectedKeys);

    const allUuid = products.map((i) => i.uuid);

    if (selectedAll) {
      allUuid.forEach((i) => {
        if (!_keys.includes(i)) {
          _keys.push(i);
        }
      });
    }
    //加上没选的
    currentPageSelection.forEach((uuid) => {
      if (!_keys.includes(uuid)) {
        _keys.push(uuid);
      }
    });
    //得出没选的
    const unSelectedUuid = allUuid.filter((uuid) => {
      return !currentPageSelection.includes(uuid);
    });

    //剔除没选的
    const reKeys = _keys.filter((uuid) => {
      return !unSelectedUuid.includes(uuid);
    });

    setMappedSelectedKeys(reKeys);
  };

  // useEffect(() => {
  //   updateMappedSelectedKeys();
  // }, [selectedRowKeys]);
  useEffect(() => {
    if (selectedAll) {
      const _keys = _.cloneDeep(mappedSelectedKeys);
      for (const product of products) {
        const { uuid } = product;
        if (!mappedSelectedKeys.includes(uuid)) {
          _keys.push(uuid);
          // _selected.push(uuid);
        }
      }
      setMappedSelectedKeys(_keys);
    }
    ///新的初始化
    const _selected = [];
    for (const product of products) {
      const { uuid } = product;
      if (mappedSelectedKeys.includes(uuid)) {
        _selected.push(uuid);
      }
      if (selectedAll) {
        _selected.push(uuid);
      }
    }
    setSelectedRowKeys(_selected);
  }, [products]);
  return {
    setMappedSelectedKeys,
    //mappedSelectedKeys,
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    setSelectedRowKeys,
  };
};
export { useQueries, convertQuery, useSelectRows };
